import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2, Lock } from "lucide-react";

export default function Review() {
  const { token } = useParams();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        await api.post(`/review/${token}`);
        const u = await refresh();
        if (u) navigate("/");
        else setError(true);
      } catch {
        setError(true);
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background grain p-6 text-center">
      <Logo size={44} />
      {error ? (
        <div className="mt-8" data-testid="review-expired">
          <Lock className="h-7 w-7 text-muted-foreground mx-auto mb-3" />
          <h1 className="font-display text-3xl text-white">Review link unavailable</h1>
          <p className="text-muted-foreground mt-2">This preview review link is invalid or has expired. Ask for a fresh link.</p>
        </div>
      ) : (
        <div className="mt-8 flex items-center gap-2 text-muted-foreground" data-testid="review-loading">
          <Loader2 className="h-4 w-4 animate-spin" /> Opening your read-only preview…
        </div>
      )}
    </div>
  );
}
